import { app } from '../../../app.module'
/**
 * 投稿のメモ管理ボタン
 * @class PostMemoManagementButton
 */
class PostMemoManagementButton {
  private accountModalFlg: string
  private memoButtonChange: Function
  private postId: string
  private snsType: string
  private memoCount: number

  constructor(
    private $rootScope,
    private $mdDialog: {
      show: Function
    }
  ) {
    // メモ数が変更されるイベント
    $rootScope.$on('changeMemo', (event, changeInfo) => {
      // 対象投稿のメモ数が変更される場合
      if (
        changeInfo.objectType === 'post' &&
        changeInfo.objectId === this.postId &&
        changeInfo.snsType === this.snsType
      ) {
        switch (changeInfo.type) {
          case 'add':
            this.memoCount = this.memoCount + 1
            break
          case 'delete':
            this.memoCount = this.memoCount - 1
            break
        }
      }
    })
  }

  /**
   * メモ管理ボタンをクリックした際の処理
   */
  public showMemoManagement(): void {
    if (this.accountModalFlg === 'true') {
      this.memoButtonChange({
        postId: this.postId,
      })
      return
    }

    this.$mdDialog.show({
      template: `<memo-management-modal object-type="post" object-id=${this.postId} sns-type=${this.snsType}></memo-management-modal>`,
      clickOutsideToClose: true,
    })
  }
}

app.component('postMemoManagementButton', {
  bindings: {
    postId: '@',
    snsType: '@',
    accountModalFlg: '@',
    memoButtonChange: '&',
    memoCount: '=',
  },
  template: require('./memo-management-button.pug')(),
  controller: PostMemoManagementButton,
})
